import React from "react";

import Draggable from "../../Draggable";
import Label from "../Label";
import Validation from "../Validation";
import { FormElement } from "../shared-style";

import { StyledRange, Background, ValueBar, Slide, SlideButton, SlideValue } from "./styles";
import { IProps } from "./interfaces";

const Range = ({ label, value, onChange, disabled, min, max, required, validation, step, scale = 1, onStop, name }: IProps) => (
    <FormElement>
        {label && (
            <Label disabled={disabled} required={required}>
                {label}
            </Label>
        )}
        {validation && <Validation validation={validation} />}
        <StyledRange>
            <Background />
            <ValueBar style={{ width: ((value - min) / (max - min)) * 100 + "%" }} />
            <Slide>
                <Draggable
                    position={{ x: ((value - min) / (max - min)) * 100 * 2, y: 0 }}
                    onDrag={(x: number) => {
                        let val = min + (x / 200) * (max - min);
                        val = Math.min(val, max);
                        val *= 1 / step;
                        val = Math.round(val);
                        val /= 1 / step;
                        onChange(val, name);
                    }}
                    onStop={() => {
                        if (onStop) onStop();
                    }}
                    scale={scale}
                >
                    <SlideButton />
                </Draggable>
                <SlideValue style={{ transform: `translateX(${((value - min) / (max - min)) * 100 * 2}px)` }}>{value}</SlideValue>
            </Slide>
        </StyledRange>
    </FormElement>
);

export default Range;
